import React from 'react';

import Logger from 'utils/Logger';

import { ToggleSelectGroup, ToggleSelectOption } from './ToggleSelect-styled-components';

interface ToggleSelectProps {
  options: string[];
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  isInvalid?: boolean;
  isSensitive?: boolean;
}

export const ToggleSelect = ({
  options,
  value,
  onChange,
  required,
  isInvalid,
  isSensitive = true,
}: ToggleSelectProps) => {
  if (!options?.length) {
    Logger.error('ToggleSelect: No options provided');
  }

  const sensitiveClassName = isSensitive ? 'sensitive-data' : '';

  return (
    <ToggleSelectGroup
      className={sensitiveClassName}
      required={required}
      value={value}
      onChange={onChange}
    >
      {options.map((option) => (
        <ToggleSelectOption key={option} value={option} $isInvalid={isInvalid}>
          {option}
        </ToggleSelectOption>
      ))}
    </ToggleSelectGroup>
  );
};
